import { isValidElement } from 'react';

export default isValidElement<any>;
